/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_OverpaidInputs */

const vi_order_overpaid = /** @type {(inputs: Order_OverpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách trả thừa`)
};

/**

* @param {Order_OverpaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_overpaid = /** @type {((inputs?: Order_OverpaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_OverpaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_overpaid(inputs)
});